import { paginateResults } from 'ui/table/utils';

/**
 * useClientPaginatedRows
 * Custom hook that can be used to paginate rows based on page and pageSize.
 * Useful for client-side pagination. There is also another hook that makes use of this function
 * to keep track of all the state needed for client-side pagination. If this is desired, take a look at:
 * - /src/ui/table/hooks/useClientPaginatedState.tsx
 */
export const useClientPaginatedRows = <DataType extends Record<string, any>>(
  unpaginatedRows: DataType[],
  currentPage: number,
  itemsPerPage: number,
) => {
  return paginateResults(unpaginatedRows, { page: currentPage, pageSize: itemsPerPage });
};
